<div class="inv-main">
  <div class="add-member-side w-100">
    <span class="add-member-text">{{ 'team_transaction_permission.title' | translate }}</span>
    <p>{{ 'team_transaction_permission.description' | translate }}</p>
  </div>
  <div class="buttons-side w-100">
    <button mat-button class="cancel-btn" type="button" (click)="turnOff()">{{ 'team_transaction_permission.turn_off' | translate }}</button>
    <button mat-button class="save-btn" type="submit" (click)="turnOn()">{{ 'team_transaction_permission.turn_on' | translate }}</button>
  </div>
</div>
